import React,{useState,useEffect} from 'react';
import {HashRouter as Router,Routes,Route} from 'react-router-dom';
import {AnimatePresence} from 'framer-motion';
import Layout from './components/Layout';
import LoadingScreen from './components/LoadingScreen';
import ScrollToTop from './components/ScrollToTop';
import Homepage from './pages/Homepage';
import AboutUs from './pages/AboutUs';
import AssignmentSupport from './pages/AssignmentSupport';
import TutoringServices from './pages/TutoringServices';
import ContactUs from './pages/ContactUs';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import FAQ from './pages/FAQ';
import BookTutor from './pages/BookTutor';
import BecomeTutor from './pages/BecomeTutor';
import OnlineExamHelp from './pages/OnlineExamHelp';
import ChatBot from './components/ChatBot';

function App() {
  const [isLoading,setIsLoading]=useState(true);
  
  const handleLoadingComplete=()=>{
    setIsLoading(false);
  };

  useEffect(()=>{
    // Ensure minimum loading time for better UX
    const minLoadingTime=setTimeout(()=>{
      if (!isLoading) return;
    },2000);
    
    return ()=> clearTimeout(minLoadingTime);
  },[isLoading]);

  return (
    <>
      <AnimatePresence mode="wait">
        {isLoading && (
          <LoadingScreen onLoadingComplete={handleLoadingComplete} />
        )}
      </AnimatePresence>
      
      {!isLoading && (
        <Router>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/assignment-support" element={<AssignmentSupport />} />
              <Route path="/tutoring-services" element={<TutoringServices />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/terms" element={<TermsConditions />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/book-tutor" element={<BookTutor />} />
              <Route path="/become-tutor" element={<BecomeTutor />} />
              <Route path="/online-exam-help" element={<OnlineExamHelp />} />
            </Routes>
          </Layout>
          <ChatBot />
        </Router>
      )}
    </>
  );
}

export default App;